import { useGetMenuResponse } from "../../hooks/useGetMenuResponse";
import type { MenuGroup } from "../../services/types/menu";

export const useGetMenuGroup = (menuGroupIdId: string): MenuGroup | undefined => {
  const menuResponse = useGetMenuResponse();
  return menuResponse?.groups.find((group) => group.id === menuGroupIdId);
};
